import React from 'react';
import { func, shape } from 'prop-types';
import { Input } from '@fiverr-private/fit';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { BRIEF_DATA } from '../../../Listings/constants';
import IndustryPicker from '../../../IndustryPicker';
import classes from '../index.module.scss';

const NameIndustries = ({ briefData, setBriefData }) => (
    <div className={classes.contentWrapper}>
        <label className={classes.label}>
            <div className={classes.caption}>
                <I18n k="variations_display.marketplace.modal.tell_about_brand.brand_name_input.title" />
            </div>
            <Input
                value={briefData.brandName}
                placeholder={translate(
                    'variations_display.marketplace_listing.brief.placeholder.brandName'
                )}
                onChange={(e) =>
                    setBriefData({ brandName: e.currentTarget.value })
                }
            />
        </label>
        <label className={classes.label}>
            <div className={classes.caption}>
                <I18n k="variations_display.marketplace_listing.brief.label.industries" />
                <span className={classes.labelHint}>
                    <I18n k="variations_display.marketplace.modal.make_your_logo.industry_input.restriction" />
                </span>
            </div>
            <IndustryPicker
                values={briefData.industries}
                className={classes.industryPicker}
                placeholder={translate(
                    'variations_display.marketplace_listing.brief.placeholder.industries'
                )}
                onChange={(industries) => setBriefData({ industries })}
            />
        </label>
    </div>
);

NameIndustries.propTypes = {
    briefData: shape(BRIEF_DATA),
    setBriefData: func,
};

export default NameIndustries;
